import React from 'react';
import { styled } from 'goober';

import { ImportJobStatus } from '@common/api';
import { useI18nContext } from '../../i18n/i18n-react';

import { ThemeColorKeys } from '@base/useTheme';

const Label = styled('span')<{ $colorType: ThemeColorKeys }>(({ theme, $colorType }) => ({
    fontWeight: 500,
    fontSize: '12px',
    color: theme.colors[$colorType].w500,
    maxWidth: 'max-content',
    borderRadius: '6px',
}));

const statusColorTypeMap: Record<ImportJobStatus, ThemeColorKeys> = {
    [ImportJobStatus.CREATED]: 'warning',
    [ImportJobStatus.COMMITED]: 'success',
    [ImportJobStatus.ARCHIVED]: 'function',
    [ImportJobStatus.REVERTED]: 'error',
};

export const statusMessageMap = {
    [ImportJobStatus.CREATED]: 'In progress',
    [ImportJobStatus.COMMITED]: 'Commited',
    [ImportJobStatus.ARCHIVED]: 'Archived',
    [ImportJobStatus.REVERTED]: 'Reverted',
} as const;

interface ImportJobStatusLabelProps {
    status: ImportJobStatus;
}

export function ImportJobStatusLabel({ status }: ImportJobStatusLabelProps): JSX.Element {
    const { LL } = useI18nContext();
    const colorType = statusColorTypeMap[status];
    return <Label $colorType={colorType}>{LL.STATUS_MESSAGE_MAP[statusMessageMap[status]]()}</Label>;
}
